import { render, staticRenderFns } from "./ExternalUrls.vue?vue&type=template&id=5a28499c&scoped=true&"
import script from "./ExternalUrls.vue?vue&type=script&lang=js&"
export * from "./ExternalUrls.vue?vue&type=script&lang=js&"
import style0 from "./ExternalUrls.vue?vue&type=style&index=0&id=5a28499c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a28499c",
  null
  
)

export default component.exports